module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/lawson-b12b5cecd3688a1b9aab6a2119e793f1.jpg";